interface AppConfig {
  apiUrl: string;
  appName: string;
  sentryDsn: string;
  environment: string;
}

declare global {
  interface Window {
    __APP_CONFIG__?: Partial<AppConfig>;
  }
}

const defaultConfig: AppConfig = {
  apiUrl: import.meta.env.VITE_API_URL ?? '',
  appName: import.meta.env.VITE_APP_NAME ?? 'APEPS',
  sentryDsn: import.meta.env.VITE_SENTRY_DSN ?? '',
  environment: import.meta.env.VITE_ENVIRONMENT ?? 'development',
};

const isPlaceholder = (value: unknown): boolean =>
  typeof value === 'string' && value.startsWith('__') && value.endsWith('__');

const runtimeConfig = Object.fromEntries(
  Object.entries(window.__APP_CONFIG__ ?? {}).filter(([, v]) => !isPlaceholder(v))
);

export const config: AppConfig = {
  ...defaultConfig,
  ...runtimeConfig,
};
